import {HTTP_NOT_FOUND} from '@/constants';
import lodash from 'lodash';
import {
    WINDOW_WIDTH_RESPONSIVE_MOBILE
} from '@/constants';

const datePickerInit = () => {
    const elements = $('.input-datepicker-container .input__field');
    elements.datepicker('remove');
    elements.datepicker({
        format: Lang.get('common.format_js_date_input'),
        todayHighlight: true,
        templates: {
            leftArrow: '<i class="fa fa-caret-left"></i>',
            rightArrow: '<i class="fa fa-caret-right"></i>'
        },
        startDate: '-0d',
        language: 'ja',
    });
};

let isModalShowing = false;

const alertMessages = (options, callback = null) => {
    if (isModalShowing) {
        return;
    }

    isModalShowing = true;

    const finalOptions = {
        container: 'body',
        title: null,
        messages: [],
        okButtonText: options.buttonText ? options.buttonText : Lang.get('common.button_ok'),
        ...options,
    };
    const {container, title, messages} = finalOptions;
    if (! messages) return;
    let displayMessages = [];
    if (typeof messages === 'string') {
        displayMessages.push(messages);
    } else if (Array.isArray(messages)) {
        displayMessages = messages;
    } else if (typeof messages === 'object') {
        for (let key in messages) {
            if (messages.hasOwnProperty(key)) displayMessages.push(...messages[key]);
        }
    }
    displayMessages = lodash.uniq(displayMessages);
    const renderMessages = displayMessages.join('<br>');
    let extendedClasses = '';
    if ($('.modal-backdrop').length) extendedClasses += ' modal-level-2';
    $(container).find('.alert-messages-modal').remove();
    $(container).append(`
        <div id="final-modal" class="modal fade alert-messages-modal modal-container modal-confirm${extendedClasses}" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">${ title }</h4>
                    </div>
                    <div class="modal-body">
                        <p style="white-space: pre-wrap;">${ renderMessages }</p>
                    </div>
                    <div class="modal-footer">
                        <button id="final-button" class="button button--flat button--color-blue button-size--small close-confirm-modal">
                            <span class="button__text d-inline-flex">${ finalOptions.okButtonText }</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    `);

    if (callback) {
        $(container).on('click', '#final-button', function (event) {
            event.preventDefault();
            window.$('#final-modal').modal('hide');
            $('#final-modal').on('hidden.bs.modal', function () {
                callback && callback();
            });
        });
    }
    $(container).find('.alert-messages-modal').one('shown.bs.modal', () => {
        isModalShowing = false;
    }).modal('show');
};

const alertConfirmMessages = (options, callback = null, cancelCallback=null) => {
    if (isModalShowing) {
        return;
    }

    isModalShowing = true;

    const finalOptions = {
        container: 'body',
        title: null,
        messages: [],
        okButtonText: options.buttonText ? options.buttonText : Lang.get('common.button_execute'),
        cancelButtonText: options.cancelButtonText ? options.cancelButtonText : Lang.get('common.button_cancel'),
        ...options,
    };
    const {container, title, messages} = finalOptions;
    if (! messages) return;
    let displayMessages = [];
    if (typeof messages === 'string') {
        displayMessages.push(messages);
    } else if (Array.isArray(messages)) {
        displayMessages = messages;
    } else if (typeof messages === 'object') {
        for (let key in messages) {
            if (messages.hasOwnProperty(key)) displayMessages.push(...messages[key]);
        }
    }
    displayMessages = lodash.uniq(displayMessages);
    const renderMessages = displayMessages.map(message => `<p style="white-space: pre-wrap;">${ message }</p>`).join('');
    let extendedClasses = '';
    if ($('.modal-backdrop').length) extendedClasses += ' modal-level-2';
    $(container).find('.alert-messages-modal').remove();
    $(container).off('click');
    $(container).append(`
        <div id="final-confirm-modal" class="modal fade alert-messages-modal modal-container modal-confirm${extendedClasses}" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">${ title }</h4>
                    </div>
                    <div class="modal-body">
                        ${ renderMessages }
                    </div>
                    <div class="modal-footer">
                        <button id="final-confirm-button-cancel" class="button button--flat button--color-red button-size--small close-confirm-modal">
                            <span class="button__text d-inline-flex">${ finalOptions.cancelButtonText }</span>
                        </button>
                        <button id="final-confirm-button" class="button button--flat button--color-blue button-size--small">
                            <span class="button__text d-inline-flex">${ finalOptions.okButtonText }</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    `);

    if (callback) {
        $(container).on('click', '#final-confirm-button', function (event) {
            event.preventDefault();
            window.$('#final-confirm-modal').modal('hide');
            $('#final-confirm-modal').on('hidden.bs.modal', function () {
                callback && callback();
            });
        });
    }
    if (cancelCallback) {
        $(container).on('click', '#final-confirm-button-cancel', function (event) {
            event.preventDefault();
            window.$('#final-confirm-modal').modal('hide');
            $('#final-confirm-modal').on('hidden.bs.modal', function () {
                cancelCallback && cancelCallback();
            });
        });
    }
    $(container).find('.alert-messages-modal').one('shown.bs.modal', () => {
        isModalShowing = false;
    }).modal('show');
};

const alertValidatorMessages = (options, callback = null) => {
    if (isModalShowing) {
        return;
    }

    isModalShowing = true;

    const finalOptions = {
        container: 'body',
        title: null,
        messages: [],
        okButtonText: options.buttonText ? options.buttonText : Lang.get('common.button_ok'),
        ...options,
    };
    const {container, title, messages} = finalOptions;
    if (! messages) return;
    let displayMessages = [];
    if (Array.isArray(messages)) {
        displayMessages = messages;
    }
    displayMessages = lodash.uniq(displayMessages);
    const renderMessages = displayMessages.map(message => `<p style="white-space: pre-wrap;">${ message }</p>`).join('');
    let extendedClasses = '';
    if ($('.modal-backdrop').length) extendedClasses += ' modal-level-2';
    $(container).find('.alert-messages-modal').remove();
    $(container).append(`
        <div id="validator-modal" class="modal fade alert-messages-modal modal-container modal-confirm${extendedClasses}" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">${ title }</h4>
                    </div>
                    <div class="modal-body">
                        ${ renderMessages }
                    </div>
                    <div class="modal-footer">
                        <button id="final-button" class="button button--flat button--color-blue button-size--small close-confirm-modal" onclick="window.location.reload()">
                            <span class="button__text d-inline-flex">${ finalOptions.okButtonText }</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    `);

    $(container).find('.alert-messages-modal').one('shown.bs.modal', () => {
        isModalShowing = false;
    }).modal('show');
};

const alertLineMesssage = (options) => {
    const finalOptions = {
        container: 'body',
        title: null,
        messages: [],
        ...options,
    };

    const {container, title, messages} = finalOptions;
    const renderMessages = messages.map(message => `<p style="white-space: pre-wrap;">${ message }</p>`).join('');
    const okButtonText = Lang.get('common.button_line_ok');
    let extendedClasses = '';
    if ($('.modal-backdrop').length) extendedClasses += ' modal-level-2';
    $(container).find('.alert-messages-modal').remove();
    $(container).append(`
        <div class="modal fade alert-messages-modal modal-container modal-confirm${extendedClasses}" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">${ title }</h4>
                    </div>
                    <div class="modal-body">
                        ${ renderMessages }
                    </div>
                    <div class="modal-footer">
                        <button class="button button--flat button--color-blue button-size--small close-confirm-modal">
                            <span class="button__text d-inline-flex">${ okButtonText }</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    `);
    $(container).find('.alert-messages-modal').modal('show');
};

const alertValidationLineErrorMessages = (title, messages, container = 'body') => {
    return alertLineMesssage({title, messages, container});
};

const alertValidationErrorMessages = (errors, container = 'body' , _option = {}, isMessageList = false, callback = null) => {
    const title = _option.title ? _option.title : Lang.get('common.title_has_validation_errors');
    const messages = [];
    if (typeof errors === 'string') {
        messages.push(errors);
        return alertMessages({... _option, title, messages, container}, callback);
    }

    if (isMessageList) {
        for (let key in errors) {
            if (errors.hasOwnProperty(key)) messages.push(errors[key]);
        }
        return alertMessages({... _option, title, messages, container}, callback);
    }

    for (let key in errors) {
        if (errors.hasOwnProperty(key)) messages.push(...errors[key]);
    }
    return alertMessages({... _option, title, messages, container}, callback);
};

const alertValidationMessages = (errors, container = 'body' , _option = {}, isMessageList = false, callback = null) => {
    const title = _option.title ? _option.title : Lang.get('common.title_has_validation_errors');
    const messages = [];
    if (typeof errors === 'string') {
        messages.push(errors);
        return alertValidatorMessages({... _option, title, messages, container}, callback);
    }
    return alertValidatorMessages({... _option, title, messages, container}, callback);
};

const alertInvalidRequest = (container = 'body') => {
    const title = Lang.get('common.title_error');
    const messages = [Lang.get('common.error_invalid_request')];
    return alertMessages({title, messages, container});
};

const calculateLengthOfStringInBytes = (string) => {
    let lengthByte = 0;
    for (let i = 0; i < string.length; i++) {
        const c = string.charCodeAt(i);
        // Shift_JIS: 0x0 ～ 0x80, 0xa0 , 0xa1 ～ 0xdf , 0xfd ～ 0xff
        // Unicode : 0x0 ～ 0x80, 0xf8f0, 0xff61 ～ 0xff9f, 0xf8f1 ～ 0xf8f3
        if ( (c >= 0x0 && c < 0x81) || (c === 0xf8f0) || (c >= 0xff61 && c < 0xffa0) || (c >= 0xf8f1 && c < 0xf8f4)) {
            lengthByte += 1;
        } else {
            lengthByte += 2;
        }
    }
    return lengthByte;
};


function axiosErrorHandler(error, message = {}, callback = null, isAlertCallback = true) {

    let alertTextMessage = {
        title: message.title ? message.title : Lang.get('common.title_error'),
        messages: message.message ? message.message : Lang.get('common.invalid'),
    };

    if (error.response.status === HTTP_NOT_FOUND) {
        alertTextMessage = {
            title: message.title ? message.title : Lang.get('common.title_error'),
            messages: message.message ? message.message : Lang.get('common.text_not_found'),
        };
    }

    if (isAlertCallback) {
        alertMessages(alertTextMessage, callback);
    } else if (callback) {
        callback();
        alertMessages(alertTextMessage);
    }

    return;
}

function popup(url, title, w, h) {
    // Fixes dual-screen position Most browsers Firefox
    let dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
    let dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;
    let width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    let height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    let left = ((width / 2) - (w / 2)) + dualScreenLeft;
    let top = ((height / 2) - (h / 2)) + dualScreenTop;
    let newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    // Puts focus on the newWindow
    if (window.focus) {
        newWindow.focus();
    }
    return newWindow;
}

const isMobileScreen = () =>{
    return window.innerWidth <= WINDOW_WIDTH_RESPONSIVE_MOBILE;
};

const renderPositionBookingCalendar = (target, isDay = false, classCalendar = 'calendar__detail-grid') => {
    const modalW = 350;
    const modalH = 350;

    let positionBox = target.getBoundingClientRect();
    let left = positionBox.left - modalW;
    let top = positionBox.top;

    const dom = document.getElementsByClassName(classCalendar)[0] || null;
    if (dom) {
        const bounding = dom.getBoundingClientRect();

        if (positionBox.top < bounding.top + modalH) {
            top = positionBox.top;
        }

        if (positionBox.top > bounding.bottom - modalH) {
            top = positionBox.top - modalH;
        }

        if (positionBox.top < bounding.bottom - modalH && positionBox.top > bounding.top + modalH) {
            top = positionBox.top - modalH;
        }

        if (positionBox.left < bounding.left + modalW) {
            left = positionBox.right;
        }

        if (positionBox.left > bounding.right - modalW) {
            left = positionBox.left - modalW;
        }

        if (top < 0) {
            top = 0;
        }

        if (isDay) {
            left = '50%!important';
        }
    }

    return `position:fixed;right:auto !important;bottom:auto !important;top:${top}px !important; left:${left}px !important`;
};

const renderPositionBookingLoadMoreCalendar = (target, isDay = false, classCalendar = 'calendar__detail-grid') => {
    const modalW = 315;
    const modalH = 350;

    let positionBox = target.getBoundingClientRect();
    let left = positionBox.left;
    let top = 0;

    const dom = document.getElementsByClassName(classCalendar)[0] || null;
    if (dom) {
        const bounding = dom.getBoundingClientRect();

        if (positionBox.top < bounding.top + modalH) {
            top = positionBox.top;
        }

        if (positionBox.top > bounding.top - modalH) {
            top = - (modalH - positionBox.height);
        }

        if (positionBox.left < bounding.right/2) {
            left = positionBox.width;
        }

        if (positionBox.left > bounding.right/2) {
            left = - modalW;
        }

        if (positionBox.bottom - modalH  < bounding.top) {
            top = 0;
        }
    }

    return `position:fixed;right:auto !important;bottom:auto !important;top:${top}px !important; left:${left}px !important`;
};

const renderPositionScreenLoadMoreCalendar = (target, classCalendar = 'calendar__detail-grid') => {
    const modalW = 230;

    let positionBox = target.getBoundingClientRect();
    let left = positionBox.left;
    let top = positionBox.top;
    const dom = document.getElementsByClassName(classCalendar)[0] || null;
    if (dom) {
        const bounding = dom.getBoundingClientRect();

        top = positionBox.top;

        left = positionBox.left + bounding.left;
    }

    return `position:fixed;width:${modalW}px !important;right:auto !important;bottom:auto !important;top:${top}px !important; left:${left}px !important`;
};

const isMobileDevice = () => {
    const patten = /(iPhone|iPad|Android|webOS|BlackBerry|IEMobile|Opera)/i;
    return !!navigator.userAgent.match(patten);
};

const showTooltip = (element, message) => {
    const $element = window.$(element);
    window.$('.tooltip').tooltip('hide');

    $element.tooltip({
        trigger: 'click',
        placement: 'bottom',
        title: message
    }).tooltip('show');

    setTimeout(function() {
        $element.tooltip('hide');
    }, 1000);
};

const copyText = (text) => {
    const fakeElem = document.createElement('div');
    fakeElem.textContent = text;
    fakeElem.setAttribute('contentEditable', true);
    document.body.appendChild(fakeElem);
    window.getSelection().selectAllChildren(fakeElem);
    try {
        document.execCommand('copy');
    } catch (error) {
        return false;
    }
    window.getSelection().removeAllRanges();
    document.body.removeChild(fakeElem);
    return true;
};

export {
    datePickerInit,
    alertMessages,
    alertConfirmMessages,
    alertValidationErrorMessages,
    alertValidationMessages,
    alertInvalidRequest,
    alertValidationLineErrorMessages,
    calculateLengthOfStringInBytes,
    axiosErrorHandler,
    popup,
    isMobileScreen,
    renderPositionBookingCalendar,
    renderPositionBookingLoadMoreCalendar,
    renderPositionScreenLoadMoreCalendar,
    isMobileDevice,
    showTooltip,
    copyText
};
